function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24Z",
  fill: "#A4DB68"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8727 26.5729L17.8983 22.3799C17.2806 21.7292 16.2808 21.7286 15.6635 22.3805C15.0458 23.032 15.0458 24.0875 15.6635 24.7396L20.7553 30.1119C21.0637 30.4373 21.4678 30.5999 21.8727 30.5999C22.2769 30.5999 22.6824 30.4373 22.9907 30.1112L32.3372 20.2469C32.9545 19.5955 32.9545 18.5393 32.3372 17.8885C31.7199 17.237 30.7191 17.237 30.1024 17.8885L21.8727 26.5729Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24 44.9C12.4572 44.9 3.1 35.5428 3.1 24H0.9C0.9 36.7578 11.2422 47.1 24 47.1V44.9ZM44.9 24C44.9 35.5428 35.5428 44.9 24 44.9V47.1C36.7578 47.1 47.1 36.7578 47.1 24H44.9ZM24 3.1C35.5428 3.1 44.9 12.4572 44.9 24H47.1C47.1 11.2422 36.7578 0.9 24 0.9V3.1ZM24 0.9C11.2422 0.9 0.9 11.2422 0.9 24H3.1C3.1 12.4572 12.4572 3.1 24 3.1V0.9Z",
  fill: "white"
});

var SvgCircleCheck = function SvgCircleCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CircleCheck.82a3a87e.svg";
export { ForwardRef as ReactComponent };